import { render, staticRenderFns } from "./NgoFilterSidebar.vue?vue&type=template&id=befdb880&scoped=true&"
import script from "./NgoFilterSidebar.vue?vue&type=script&lang=js&"
export * from "./NgoFilterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NgoFilterSidebar.vue?vue&type=style&index=0&id=befdb880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befdb880",
  null
  
)

export default component.exports